import { type IconComponent, LinkIcon, SocialLinkedinIcon, SocialXIcon } from '@blockworks/ui/icon';

import ResearchConfig from '@/research-config';

export interface ISocialSharingLinks {
    name: string;
    url: string;
    icon?: IconComponent;
    copyToClipboard?: boolean;
}

export const socialSharingLinks = (path: string): ISocialSharingLinks[] => {
    return [
        {
            name: 'Twitter',
            url: `https://twitter.com/intent/tweet?url=${ResearchConfig.SITE_URL}${path}`,
            icon: SocialXIcon,
        },
        {
            name: 'LinkedIn',
            url: `https://www.linkedin.com/sharing/share-offsite?url=${ResearchConfig.SITE_URL}${path}`,
            icon: SocialLinkedinIcon,
        },
        {
            name: 'Copy to Clipboard',
            url: `${ResearchConfig.SITE_URL}${path}`,
            icon: LinkIcon,
            copyToClipboard: true,
        },
    ];
};
